import * as React from 'react';
import { ExamPracticalSectionShowView } from '../../../types/exam_sections';
import { PracticalSectionEyeCatch } from '../../molecules/exam_sections/PracticalSectionEyeCatch';
import './examPracticalSectionView.module.scss';

const SubSection = ({ label, children }) => (
  <div styleName="sub-section">
    <div styleName="sub-section-label">{label}</div>
    <div styleName="sub-section-body">{children}</div>
  </div>
);

const RawHtmlView = ({ children }) => <div styleName="raw-html" dangerouslySetInnerHTML={{ __html: children }} />;

type Props = {
  section: ExamPracticalSectionShowView;
};

export class ExamPracticalSectionView extends React.Component<Props> {
  render() {
    const { section } = this.props;
    return (
      <div styleName="view" id="section-detail-pane">
        <PracticalSectionEyeCatch
          title={section.title}
          courseTitle={section.course.title}
          sectionId={section.id}
          imageRef={section.eye_catch}
          submissionPlaceUrl={section.submission_place_url}
        />
        <div styleName="body">
          <SubSection label="クリア条件">
            <RawHtmlView>{section.clear_condition}</RawHtmlView>
          </SubSection>
          <SubSection label="採点項目">
            <RawHtmlView>{section.evaluation_details}</RawHtmlView>
          </SubSection>
          <SubSection label="内容">
            <RawHtmlView>{section.challenge_description}</RawHtmlView>
          </SubSection>
          <SubSection label="提出方法">
            <RawHtmlView>{section.submission_instruction}</RawHtmlView>
          </SubSection>
          <SubSection label="過去の提出作品">
            <a target="_blank" href={section.submission_place_url}>
              こちらのページから、
            </a>
            過去の合格者のページが閲覧できます。
          </SubSection>
        </div>
      </div>
    );
  }
}
